<template>

  <div id="app" class="h-100">
      <router-view name="sidebar"/>
      
        <transition
        name="fade"
        mode="out-in"
      >
        <router-view name="main"/>
        </transition>

        <Footer/>
      
        
      
    
  </div>
</template>

<script>
import Footer from "../components/Footer"
export default {
  name : 'App',
  components: {
    Footer
  },


  mounted(){
    let themejs = document.createElement('script')
    themejs.setAttribute('src', 'https://kit.fontawesome.com/2457aa6323.js')
    document.head.appendChild(themejs)
  }
}
</script>

<style>

@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@1,300&display=swap');

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

.login {
    background-color:lightblue!important;
}

.contact {
  background-color: #FFDFD3;
}

.admin {
  background-color: whitesmoke;
}

.musee {
    background-color: #f0f0f0;
}

.logis {
  background-image: url('../assets/imgs/giverny.jpg');
  background-size:cover;
 
}

.gaillon {
  background-image: url('../assets/imgs/gaillon.jpg');
  background-size:cover;
 
}
.checked {
  color: orange;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
